/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Usage_Never_Item_1Inputs */

const es_privacy_policy_usage_never_item_1 = /** @type {(inputs: Privacy_Policy_Usage_Never_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicidad dirigida a terceros`)
};

const en_privacy_policy_usage_never_item_1 = /** @type {(inputs: Privacy_Policy_Usage_Never_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Third-party targeted advertising`)
};

/**
* | output |
* | --- |
* | "Third-party targeted advertising" |
*
* @param {Privacy_Policy_Usage_Never_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_usage_never_item_1 = /** @type {((inputs?: Privacy_Policy_Usage_Never_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Usage_Never_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_usage_never_item_1(inputs)
	return en_privacy_policy_usage_never_item_1(inputs)
});
export { privacy_policy_usage_never_item_1 as "privacy_policy.usage.never_item_1" }